import BossModel from '@/models/BossModel'
import PublicImage from '@/models/PublicImage/PublicImage';
import Presentation from "@/models/Proposal/Presentation/Presentation";
import moment from "moment";

export default class Day extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'proposal/presentation/day';

    /**
     *
     * @type {string}
     */
    static entity = 'proposalPresentationDays';

    /**
     * Relations used for normalization
     * @returns {{}}
     */

    static fields() {
		return {
			id: this.number(null).nullable(),
			proposal_presentation_id: this.number(null).nullable(),
			start_at: this.attr(null),
			end_at: this.attr(null),
			title: this.attr(null),
			sub_title: this.attr(null),
			html: this.attr(null),
			public_image_id: this.number(null).nullable(),
            presentation: this.belongsTo(Presentation, 'proposal_presentation_id'),
            publicImage: this.belongsTo(PublicImage, 'public_image_id'),
		}
	}

    /**
     *
     * @param presentationId
     * @returns {*}
     */
    static loadByPresentation(presentationId) {
        return this.api()
            .limit(0)
            .where('proposal_presentation_id', presentationId)
            .with(['publicImage'])
            .get(true);
    }

    /**
     *
     * @param presentationId
     * @returns {*}
     */
    static byPresentation(presentationId) {
        return this.all().filter(item => item.proposal_presentation_id == presentationId);
    }

    /**
     *
     * @returns {null|*}
     */
    GetNext() {
        let days = this.Presentation().Days();
        let currentIndex = days.findIndex(day => day.id === this.id);
        if (currentIndex < days.length - 1) {
            return days[currentIndex + 1];
        }

        return null;
    }

    /**
     *
     * @param presentationId
     * @param groupPackageId
     * @param startDate
     * @returns {Promise<AxiosResponse<T>>}
     */
    static SaveByPackage(presentationId, groupPackageId, startDate) {
        return this.api().action(presentationId + '/store-by-package/' + groupPackageId)
            .create({start_date: startDate}, false);
    }

    /**
     *
     * @param presentationId
     * @param productId
     * @param startDate
     * @returns {Promise<AxiosResponse<T>>}
     */
    static SaveByProduct(presentationId, productId, startDate) {
        return this.api().action(presentationId + '/store-by-product/' + productId)
            .createMultiple({start_date: startDate});
    }

    /**
     *
     * @param presentationId
     * @param date
     * @returns {*}
     */
    static byStartAt(presentationId, date) {
        return Day.byPresentation(presentationId).filter(item => item.start_at === date);
    }

    /**
     *
     * @returns {*}
     */
    FirstStartDate() {
        const days = this.Presentation().Days();
        if (days.length <= 1) {
            return this.start_at;
        }
        let otherFirstStartDate = days.filter(item => item.id !== this.id)[0].start_at;

        if (moment(otherFirstStartDate).isAfter(this.start_at)) {
            return this.start_at;
        }

        return otherFirstStartDate;
    }

    /**
     *
     * @returns {number}
     */
    EndDayNumber() {
        let firstStartDate = this.FirstStartDate();

        return moment(this.end_at).diff(firstStartDate, 'days') + 1;
    }

    /**
     *
     * @returns {number}
     */
    StartDayNumber() {
        let firstStartDate = this.FirstStartDate();

        return moment(this.start_at).diff(firstStartDate, 'days') + 1;
    }

    /**
     *
     * @returns {boolean|*}
     */
    Presentation() {
        return this.getRelated('presentation');
    }

    /**
     *
     * @returns {boolean|*}
     */
    PublicImage() {
        return this.getRelated('publicImage');
    }

    /**
     *
     * @param view
     * @returns {Promise<AxiosResponse<T>>}
     */
    Preview() {
        return this.constructor.api().action(this.id + '/preview').getSingle(false);
    }
}
